export interface LoadRosterStructureParams {
  employeeId: number | string;
  begindate: string;
  enddate: string;
}

export abstract class RosterStructureRepository<T> {
  abstract load(params: LoadRosterStructureParams): Promise<T>;
}
